<div class="card">
  <div class="card-header d-flex justify-content-between align-items-center">
    @if (this.isHome) {
    <a
      [routerLink]="['/idolinfo']"
      [queryParams]="{ idolid: this.cardInfo.idolId }">
      <div class="d-flex align-items-center">
        <img
          [src]="this.scUrlService.getIdolSmlIcon(this.cardInfo.idolId)"
          [alt]="'Icon of idol'"
          width="30px"
          height="30px">
        <span class="ps-1">
          {{this.cardInfo.cardName.replace(this.regExp,"$2")}}
        </span>
      </div>
    </a>
    }
    @else {
      <div></div>
    }
    <div class="float-end">
      {{ this.cardInfo.releaseDate | date: "yyyy-MM-dd" }}
    </div>
  </div>
  <a
    [routerLink]="[this.pathType]"
    [queryParams]="{ uuid: this.cardInfo.cardUuid }">
    <img
      [src]="this.getPictureUrl()"
      [alt]="'Picture of ' + this.cardInfo.cardName"
      [ngClass]="{ 'card-img-top': !this.isHome, 'card-img': this.isHome, 'rounded-0': this.isHome, 'p-0': this.isHome }"
      width="1136"
      height="640"
      class="img-fluid" />
    <div class="card-body p-0 pb-2">
      <div class="card-text p-2">
        <span class="badge text-bg-info ms-1 me-1">
          {{this.cardInfo.getMethod}}
        </span>
        <span class="badge ms-1 me-1"
          [ngClass]="{
            'bg-danger': this.cardInfo.cardType.endsWith('_UR'),
            'bg-warning': this.cardInfo.cardType.endsWith('_SSR'),
            'bg-primary': this.cardInfo.cardType.endsWith('_SR'),
            'bg-secondary': this.cardInfo.cardType.endsWith('_R') || this.cardInfo.cardType.endsWith('_N'),
          }">
          {{this.cardInfo.cardType}}
        </span>
      </div>
      <h5 class="card-title text-center">
        {{ this.cardInfo.cardName.replace(this.regExp, "$1") }}
      </h5>
    </div>
  </a>
</div>
